import * as $ from 'jquery';
import * as BS from 'bootstrap';
import {Server} from './Server';
import {MapPoint} from './Types';

/**
 * Захтев за помоћ при потписивању – за особе са инвалидитетом или слабом покретљивошћу.
 * Шаље се на /support/request, а мапа остаје на месту (без освежавања стране).
 */
export class SupportForm {

    private static modal: BS.Modal;
    private static municipalitiesLoaded = false;

    public static setup(): void {
        const element = document.getElementById('supportModal');
        if (!element) {
            return;
        }
        SupportForm.modal = new BS.Modal(element);
        $('#btnSupport').on('click', () => SupportForm.open());
        $('#supportForm').on('submit', (e) => {
            e.preventDefault();
            SupportForm.submit();
        });
    }

    private static open(): void {
        SupportForm.clearMessages();
        $('#supportOk').addClass('d-none');
        $('#supportForm').removeClass('d-none');
        SupportForm.loadMunicipalities();
        SupportForm.newCaptcha();
        SupportForm.modal.show();
    }

    /** Општине се узимају из истог списка одбора који мапа ионако користи. */
    private static loadMunicipalities(): void {
        if (SupportForm.municipalitiesLoaded) {
            return;
        }
        $.get(Server.endpoint + '/events/data/points').then((points: MapPoint[]) => {
            const names = points
                .map(p => p.municipality)
                .filter(m => !!m)
                .filter((m, i, all) => all.indexOf(m) === i)
                .sort((a, b) => a.localeCompare(b, 'sr'));
            const select = $('#sMunicipality');
            names.forEach(name => select.append($('<option>').attr('value', name).text(name)));
            select.append($('<option>').attr('value', 'ДРУГО').text('Друго / није на списку'));
            SupportForm.municipalitiesLoaded = true;
        });
    }

    private static newCaptcha(): void {
        $('#sCaptcha').val('');
        $.get(Server.endpoint + '/support/captcha').then((data: { question: string }) => {
            $('#supportCaptchaQuestion').text(data.question);
        });
    }

    private static submit(): void {
        SupportForm.clearMessages();
        const button = $('#supportSubmit');
        button.prop('disabled', true);

        const request = $.ajax({
            url: Server.endpoint + '/support/request',
            method: 'POST',
            data: $('#supportForm').serialize()
        });
        request.done(() => {
            $('#supportForm').addClass('d-none');
            $('#supportOk').removeClass('d-none');
        });
        request.fail((xhr: JQuery.jqXHR) => {
            const errors = xhr.responseJSON && xhr.responseJSON.errors ? xhr.responseJSON.errors : null;
            if (!errors) {
                $('#supportError').text('Слање тренутно није успело. Покушајте поново за који тренутак.').removeClass('d-none');
            } else {
                Object.keys(errors).forEach(field => {
                    if (field === '_') {
                        $('#supportError').text(errors[field]).removeClass('d-none');
                    } else {
                        $('[data-error="' + field + '"]').text(errors[field]);
                    }
                });
            }
            // питање важи само једном – после неуспеха увек стиже ново
            SupportForm.newCaptcha();
        });
        request.always(() => button.prop('disabled', false));
    }

    private static clearMessages(): void {
        $('#supportError').addClass('d-none').text('');
        $('[data-error]').text('');
    }
}
